import type { SessionLogEntry } from "../../state/profile";

/** Reverse-chronological session history. `log` is currently always empty —
    nothing populates it yet (that lands with the Session Card persistence
    work) — so this renders a clean empty state rather than assuming data. */
export function LogbookList({ entries }: { entries: SessionLogEntry[] }) {
  if (entries.length === 0) {
    return <p class="label logbook-empty">No sessions logged yet — they'll show up here once you finish one.</p>;
  }

  const sorted = [...entries].sort((a, b) => b.at.localeCompare(a.at));
  return (
    <ul class="logbook-list">
      {sorted.map((e) => (
        <li key={e.at} class="logbook-row">
          <span class="mono logbook-date">{new Date(e.at).toLocaleDateString()}</span>
          <span class="logbook-clarity">+{e.clarity} Clarity</span>
          <span class="mono logbook-items">{e.itemsCleared} items</span>
        </li>
      ))}
    </ul>
  );
}
